import React, { useEffect, useRef, useState } from 'react';
import { usePortletTranslations } from 'js/components/system/Portlet';
import { useTranslations } from 'js/hooks/i18n';
import style from './index.scss';
import { Icon } from '../../../../common/Icon';
import { Tooltip } from '../../common/Tooltip';
import { getDevice } from '../../../../../hooks/device/helpers';

export const detectStyle = (rank, isInPrizes, isMe, showRankPrizes) => {
    let scoreStyle;
    let rankStyle;
    let eventLeftStyle;
    let nicknameStyle;
    let wrapperStyle;
    const dividerStyle = isInPrizes ? style.dividerInPrizesStyle : style.dividerGeneralStyle;

    if (isMe) {
        wrapperStyle = style.wrapperMeStyle;
        scoreStyle = style.scoreMeStyle;
        nicknameStyle = style.nicknameMeStyle; // bold white color
        eventLeftStyle = style.eventLeftMeStyle; // bold white color
        if (isInPrizes) {
            rankStyle = showRankPrizes ? style.rankMeInPrizesStyle : style.rankMeInPrizesNoHoverStyle; // transparent circle with white border; white bold font
        } else {
            rankStyle = style.rankMeGeneralStyle; // white bold font
        }
    } else {
        scoreStyle = style.scoreGeneralStyle;
        if (isInPrizes) {
            wrapperStyle = style.wrapperInPrizesStyle;
            rankStyle = showRankPrizes ? style.rankInPrizesStyle : style.rankInPrizesNoHoverStyle; // transparent circle with black border; black bold font
            eventLeftStyle = style.eventLeftInPrizesStyle; // bold black color
            nicknameStyle = style.nicknameInPrizesStyle; // bold black color
        } else {
            wrapperStyle = style.wrapperGeneralStyle;
            rankStyle = style.rankGeneralStyle; // white normal font
            eventLeftStyle = style.eventLeftGeneralStyle; // black normal color
            nicknameStyle = style.nicknameGeneralStyle; // black normal color
        }
    }
        if (rank === 1 && isInPrizes) {
            rankStyle = showRankPrizes ? style.rankGoldenCircleStyle : style.rankGoldenCircleNoHoverStyle; // golden circle no border; black bold font
        } else if (rank === 2 && isInPrizes) {
            rankStyle = showRankPrizes ? style.rankSilverCircleStyle : style.rankSilverCircleNoHoverStyle; // silver circle no border
        } else if (rank === 3 && isInPrizes) {
            rankStyle = showRankPrizes ? style.rankBronzeCircleStyle : style.rankBronzeCircleNoHoverStyle; // silver circle no border
        }
    return { scoreStyle, rankStyle, eventLeftStyle, nicknameStyle, wrapperStyle, dividerStyle };
};

export const formatScore = (x) => x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

export const NewUIHeadRowThreeCols = ({ participantsCount }) => {
    const t = usePortletTranslations();

    return (
        <div className={style.newUIHeaderThreeColsWrapper}>
            <div className={style.newUiHeaderRankThreeColsWrapper}>
                <div>{`${t('competitorsTable.head.rank')}/${participantsCount}`}</div>
            </div>
            <div className={style.newUiHeaderNickThreeColsWrapper}>
                <div>{t('competitorsTable.head.nickname')}</div>
            </div>
            <div className={style.newUiHeaderScoreThreeColsWrapper}>
                <div>{t('competitorsTable.head.score')}</div>
            </div>
        </div>
    );
};

export const NewUIHeadRowFourCols = ({ useRoundsTitle, participantsCount, useTournament }) => {

    const [toShowTooltip, setShowTooltip] = useState(false);
    const t = usePortletTranslations();

    return (
        <div className={style.newUIHeaderFourColsWrapper} >
            <div className={style.newUiHeaderRankFourColsWrapper}>
                <div>{`${t('competitorsTable.head.rank')}/${participantsCount}`}</div>
            </div>
            <div className={style.newUiHeaderNickFourColsWrapper}>
                <div>{t('competitorsTable.head.nickname')}</div>
            </div>
            <div className={style.newUiHeaderEventsFourColsWrapper} >
                <div className={style.eventOrRoundsTitle}
                    onClick={() => setShowTooltip(!toShowTooltip)}
                     onMouseEnter={() => setShowTooltip(true)}
                     onMouseLeave={() => setShowTooltip(false)}>
                    {!useRoundsTitle ? t('competitorsTable.head.events') : t('roundsleft')}
                </div>
                <Icon className={style.detailsTooltipGeneral}
                      type="detailsTooltip"
                      onClick={() => setShowTooltip(!toShowTooltip)}
                      onMouseEnter={() => setShowTooltip(true)}
                      onMouseLeave={() => setShowTooltip(false)}/>
                <div className={style.tooltipWrapper}>
                    {toShowTooltip && <Tooltip tooltipStyle='detailsRoundsStyle'
                                               onXClicked={() => setShowTooltip(false)}
                                               title={!useRoundsTitle ? t('competitorsTable.head.events') :
                                                   t('roundsleft')}
                                               text={t(useRoundsTitle
                                                   ? useTournament
                                                       ? 'competitorsTable.tooltip.roundSuggestionTournament'
                                                       : 'competitorsTable.tooltip.roundSuggestion'
                                                   : useTournament
                                                       ? 'competitorsTable.tooltip.eventSuggestionTournament'
                                                       : 'competitorsTable.tooltip.eventSuggestion')} />}
                </div>

            </div>
            <div className={style.newUiHeaderScoreFourColsWrapper}>
                <div>{t('competitorsTable.head.score')}</div>
            </div>
        </div>
    );
};

export const NewUIColsRow = (data) => {
    const {
        rank,
        name,
        isMe,
        score,
        nickName,
        addDivider,
        remainingEventCount,
        isInPrizes,
        minPointsForPrizeIssue,
        onCompetitorClickedCallback,
        showRankPrizes,
        isEventBased,
        isNextRowIsMe,
        isNextWithDivider
    } = data;

    useEffect(() => {
        if (isMe) {
            setTimeout(() => {
                if (getDevice().os === 'ios') {
                    elRef.current.scrollIntoView(false);
                } else {
                    const rect = elRef.current.getBoundingClientRect();
                    const yOffset = window.scrollY + rect.top - 50;
                    window.scrollTo({
                        top: yOffset,
                        behavior: 'smooth'
                    });
                }
            }, 500);
        }
    }, [isMe]);

    const elRef = useRef();
    const t = usePortletTranslations();
    const styleObj = detectStyle(rank, isInPrizes, isMe, showRankPrizes);
    const nameToDisplay = nickName || name;
    const [toShowTooltip, setShowTooltip] = useState(false);
    const toShowScoreTooltip = Boolean(isMe && minPointsForPrizeIssue && score < minPointsForPrizeIssue);
    let scoreTooltipText = '';
    if (toShowScoreTooltip) {
        scoreTooltipText = t(minPointsForPrizeIssue === 1
            ? 'competitorsTable.tooltip.scoreSuggestionOnePoint'
            : 'competitorsTable.tooltip.scoreSuggestion'
        ).replace('<minpoints>', minPointsForPrizeIssue);
    }
    return (
        <div ref={elRef} key={`${nameToDisplay}${rank}`}>
        {addDivider && <hr className={style.divider}/>}
        <div className={`${isEventBased ? style.newUIFourRowsWrapper : style.newUIThreeRowsWrapper} ${styleObj.wrapperStyle}`}>
            <div onClick={() => isInPrizes && onCompetitorClickedCallback(rank - 1)}
                 className={isEventBased ? style.newUIFourRowsRankWrapper : style.newUIThreeRowsRankWrapper}>
                <div className={`${styleObj.rankStyle}`} >
                    <div>{rank}</div>
                </div>
            </div>
            <div className={`${isEventBased ? style.newUIFourRowsNicknameWrapper : style.newUIThreeRowsNicknameWrapper}
            ${styleObj.nicknameStyle} `}>
                <div>{nameToDisplay}</div>
            </div>
            {isEventBased && <div className={`${style.newUIFourRowsEventsWrapper} ${styleObj.eventLeftStyle} `}>
                <div>
                    {remainingEventCount}
                </div>
            </div>}
            <div className={`${isEventBased ? style.newUIFourRowsScoreWrapper : style.newUIThreeRowsScoreWrapper}
             ${styleObj.scoreStyle} `}>
                {toShowScoreTooltip && <Icon className={style.scoreTooltipGeneral}
                      type="scoreTooltip"
                      onMouseEnter={() => setShowTooltip(true)}
                      onMouseLeave={() => setShowTooltip(false)}
                      onClick={() => setShowTooltip(!toShowTooltip)} />}
                {toShowScoreTooltip && <div className={style.tooltipWrapper}>
                    {toShowTooltip && <Tooltip tooltipStyle='detailsScoreStyle' onXClicked={() => setShowTooltip(false)}
                                               text={scoreTooltipText}/>}
                </div>}
                <div>
                    {formatScore(score)}
                </div>
            </div>
        </div>
            {!isMe && !isNextRowIsMe && !isNextWithDivider && <div className={`${styleObj.dividerStyle}`} />}
        </div>);
};

export const isEventBased = competitorsTable => competitorsTable.some(
    ({ remainingEventCount }) => typeof remainingEventCount != 'undefined');

export const trimNickNames = (competitorsTable) => {
    for (let i = 0; i < competitorsTable.length; i++) {
        if (competitorsTable[i].nickName) {
            if (competitorsTable[i].nickName.length > 12) {
                competitorsTable[i].nickName = `${competitorsTable[i].name.substr(0, 12)}...`;
            }
        }
    }
};

export const detectLowestRankForPrizes = prizesData => {
    const lastRankInPrizes = prizesData.length > 0 ? prizesData[prizesData.length - 1].loRank : -1;
    return lastRankInPrizes;
};

export default ({ onCompetitorClicked, useRoundsTitle, minPointsForPrizeIssue, competitorsTable, status,
                    participantsCount, prizes, showRankPrizes, useTournament }) => {
    trimNickNames(competitorsTable);
    const lowestRankInPrizes = detectLowestRankForPrizes(prizes);
    let updatedCompetitorsTable = competitorsTable;
    updatedCompetitorsTable = updatedCompetitorsTable.map((row) => {
        if (status === 'PENDING_REVIEW') {
            row.isMe = false;
        }
        row.isInPrizes = lowestRankInPrizes >= row.rank;
        return row;
    });
    const t = useTranslations();
    const isEventBasedLb = isEventBased(updatedCompetitorsTable);

    return (
        <div>
            {
                status === 'PENDING_REVIEW' && (
                    <div className={style.textOverlay}>
                        {t('playtech.mobile.system.casino-leaderboard.notification.pendingLeaderboard')}
                    </div>
                )
            }
            <div className={style[status] ? style[status] : ''}>
                {isEventBasedLb ?
                    <NewUIHeadRowFourCols useRoundsTitle={useRoundsTitle}
                                          participantsCount={participantsCount}
                                          useTournament={useTournament}/>
                    : <NewUIHeadRowThreeCols participantsCount={participantsCount}/>}
                {updatedCompetitorsTable
                        .map(({
                                  rank,
                                  name,
                                  nickName,
                                  score,
                                  isMe,
                                  isInPrizes,
                                  addDivider,
                                  remainingEventCount
                              }, index, array) => {
                            const isNextRowIsMe = array[index + 1] && array[index + 1].isMe;
                            const isNextWithDivider = array[index + 1] && array[index + 1].addDivider;
                            return <NewUIColsRow
                                onCompetitorClickedCallback={onCompetitorClicked}
                                isEventBased={isEventBasedLb}
                                prizes={prizes}
                                showRankPrizes={showRankPrizes}
                                key={rank}
                                isNoPrize={false}
                                isMarkRank={rank <= 3}
                                isNextRowIsMe={isNextRowIsMe}
                                isNextWithDivider={isNextWithDivider}
                                {...{ name, nickName, rank, score, minPointsForPrizeIssue, isMe, isInPrizes, addDivider,
                                    remainingEventCount }}
                            />;
                        }
                    )}
            </div>
        </div>
    );
};
